// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"b8ad7ab5","82":"0a1873d3","203":"2ff7736b","219":"4cd61291","319":"78f6542b","584":"5a880e17","715":"cb581ccd","722":"23bbce53","823":"a2c135a4","864":"4eb59513","874":"d0f4b8a3"}[chunkId] + ".chunk.js";
};